import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns a YYYY-MM-DD string using the local timezone.
 * This prevents the UTC-shift bug caused by toISOString().split("T")[0].
 */
export function getLocalDateString(date: Date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

/** Maps plan keys (e.g. "ai_coach") to proper display labels with correct capitalization. */
const PLAN_LABELS: Record<string, string> = {
  free: "Free",
  track: "Track",
  ai_coach: "AI Coach",
  coach: "Coach",
  partner: "Partner",
};

/** Converts a snake_case or camelCase identifier to a human-readable Title Case label.
 *  e.g. "fat_loss" → "Fat Loss", "sports_performance" → "Sports Performance" */
export function formatLabel(raw: string): string {
  return raw
    .replace(/_/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
}

export function formatPlanLabel(plan: string | null | undefined): string {
  if (!plan) return "Free";
  return PLAN_LABELS[plan] ?? plan.replace(/_/g, " ").replace(/\bai\b/gi, "AI").replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Normalizes a gym name for matching/deduplication.
 * Strips punctuation, collapses whitespace, lowercases.
 * e.g. "Gold's Gym" → "golds gym", "L.A. Fitness" → "la fitness"
 */
export function normalizeGymName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[.'''\-]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
